function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SquareTags from "segments/desktop/core-components/square-tags/square-tags";
import { StyledSquareTagsGridComponent } from "./square-tags-grid-component.scss";
import DefaultProps from "./default-props.js";
const SquareTagsGridComponent = (props)=>{
    return /*#__PURE__*/ _jsx(StyledSquareTagsGridComponent, {
        className: "square-tags-grid-component",
        children: /*#__PURE__*/ _jsx(SquareTags, _object_spread({}, props))
    });
};
SquareTagsGridComponent.defaultProps = DefaultProps;
export default SquareTagsGridComponent;
